// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"328":"admin","378":"user","787":"guest"}[chunkId] || chunkId) + "." + {"328":"e4aad1e9f55c8cda15d6","378":"4c5edd437b783f127584","583":"d5794866871ca061498d","787":"6c70d6431302e2375df3","889":"b747b3958fdd742a6cf4"}[chunkId] + ".css";
};